module.exports = __webpack_public_path__ + "img/cp-3.ff334f64.png";